module.exports = __webpack_public_path__ + "assets/images/7f838150017a90327b53f7bbaa305d65.png";